<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand"  [routerLink]="['']">
    <img src="/assets/images/gefrecon/POCTEP-GEFRECON-without-background.png" width="300" height="50" class="d-inline-block align-top" alt="">
  </a>
  <div class="collapse navbar-collapse d-flex flex-row-reverse" id="navbarNav" *ngIf="!isLoggedIn">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/auth/signin']">{{ 'SYSTEM.LOGIN' | translate }}<span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/auth/register']">{{ 'SYSTEM.REGISTER' | translate }}</a>
      </li>

    </ul>
  </div>
  <div class="collapse navbar-collapse d-flex flex-row-reverse" id="navbarNav" *ngIf="isLoggedIn">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['']">{{ 'FARM.VIEW_FARMS' | translate }} <span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [routerLink]="['/farm']" [queryParams]="{ isEdit: false }"> {{ 'FARM.CREATE_FARM' | translate }}</a>
      </li>
      <li>
        <div class="dropdown">
          <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="false" aria-expanded="false">
            {{ 'PROFILE.MY_PROFILE' | translate }}
          </button>
          <div class="dropdown-menu" style="z-index: 9999999999;" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" [routerLink]="['/auth/account/profile']">{{ 'PROFILE.PROFILE' | translate }}</a>
            <a class="dropdown-item" [routerLink]="['/auth/account/myfarms']">{{ 'FARM.MY_FARMS' | translate }}</a>
            <a class="dropdown-item" (click)="logout()">{{ 'SYSTEM.LOGOUT' | translate }}</a>
          </div>
        </div>
      </li>
    </ul>  
    </div>  
    <div class="ml-1">  
      <select  class="custom-select" [(ngModel)]="selected"  (ngModelChange)="useLanguage()">
        <option *ngFor="let lang of languages" [value]="lang.value">
          {{lang.viewValue}}
        </option>
      </select>
    </div>  
</nav>